import { service } from "../utils/request";

//退货地址列表
export function BackAddressList(data) {
  return service({
    url: "shop/agent.refund_address/address",
    method: "post",
    data: data
  });
}

//新增退货地址
export function AddBackAddress(data) {
  return service({
    url: "shop/agent.refund_address/create",
    method: "post",
    data: data
  });
}

//修改退货地址
export function EditBackAddress(data) {
  return service({
    url: "shop/agent.refund_address/edit",
    method: "post",
    data: data
  });
}

//退货地址详情
export function BackAddressDetail(data) {
  return service({
    url: "shop/agent.refund_address/detail",
    method: "post",
    data: data
  });
}

//删除退货地址
export function DelBackAddress(data) {
  return service({
    url: "shop/agent.refund_address/del",
    method: "post",
    data: data
  });
}
